import script from "./base-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-modal.vue?vue&type=script&setup=true&lang=ts"

import "./base-modal.vue?vue&type=style&index=0&id=74f97ed2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74f97ed2"]])

export default __exports__